import styled from '@emotion/styled';
import { KeyboardsIcon, NotFoundSvg } from '../svgs';

export const NoResultsImage = styled(NotFoundSvg)`
    max-width: 100%;
    height: auto;
`;

export const NoEntriesImage = styled(KeyboardsIcon)`
    max-width: 100%;
    height: auto;
`;
